import React, {
    createContext,
    Dispatch,
    SetStateAction,
    useContext,
    useState,
} from 'react';

const FilterTermValueContext = createContext<string>('');

const FilterTermUpdateContext = createContext<Dispatch<SetStateAction<string>>>(
    () => {}
);

const BaseFilterTermProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [filterTerm, setFilterTerm] = useState('');

    return (
        <FilterTermUpdateContext.Provider value={setFilterTerm}>
            <FilterTermValueContext.Provider value={filterTerm}>
                {children}
            </FilterTermValueContext.Provider>
        </FilterTermUpdateContext.Provider>
    );
};

const FilterTermProvider = React.memo(BaseFilterTermProvider);

export default FilterTermProvider;

export const useFilterTerm = () => useContext(FilterTermValueContext);
export const useFilterTermState = (): [
    string,
    Dispatch<SetStateAction<string>>
] => {
    const value = useContext(FilterTermValueContext);
    const setValue = useContext(FilterTermUpdateContext);

    return [value, setValue];
};
